// @flow

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';

import SpecHeader from './SpecHeader';

const Section = styled.section`
  margin: 2em auto;
  padding: 0 1em;
  text-align: center;
  &:first-of-type {
    margin-top: 1em;
  }
`;

const SpecList = styled.ul`
  list-style: none;
  margin: 0 auto;
  padding: 0;

  ${props => props.hasAfter && css`
    margin-bottom: 1em;
  `}
`;

type Props = {
  after?: Node,
  before?: Node,
  children: Node,
  title: Node
}

const SpecResultSection = ({ after, before, children, title }: Props) => (
  <Section>
    <SpecHeader>{title}</SpecHeader>
    {before}
    <SpecList hasAfter={!!after} hasBefore={!!before}>{children}</SpecList>
    {after}
  </Section>
);

export {
  Section,
  SpecList
};

export default SpecResultSection;



// WEBPACK FOOTER //
// ./src/components/SpecResultSection.js